import { QuestInventoryItem } from "./QuestInventoryItem";

export interface Diary extends QuestInventoryItem {
    name: 'Diary';
}

export function makeDiary(): Diary {
    return { name: 'Diary' };
}